<template>
    <a-modal
        :visible="true"
        width="90vw"
        :footer="null"
        :closable="false"
        :destroy-on-close="true"
        centered
        wrap-class-name="rdm-wrap"
        @cancel="$emit('close')"
    >
        <div class="rdm-modal">
            <div class="rdm-head">
                <div>
                    <h3>Cotação #{{ request_id }}</h3>
                    <div class="rdm-sub">{{ product.pro_descricao }}</div>
                </div>
                <a-tooltip title="Fechar">
                    <a-button class="rdm-x" @click="$emit('close')">
                        <span class="material-icons-outlined">close</span>
                    </a-button>
                </a-tooltip>
            </div>

            <a-tabs v-model="tab" class="rdm-tabs">
                <a-tab-pane key="STORES" tab="Requisitantes" />
                <a-tab-pane key="TYPINGS" tab="Digitações" />
                <a-tab-pane key="ORDERS" tab="Pedidos" />
            </a-tabs>

            <div class="rdm-body">
                <a-table
                    v-if="tab === 'STORES'"
                    size="small"
                    :columns="storeColumns"
                    :data-source="visibleStores"
                    :row-key="(record, index) => index"
                    :loading="loading"
                    :pagination="{ pageSize: 20, size: 'small' }"
                    :scroll="{ x: 'max-content' }"
                    :locale="{ emptyText: 'Nenhum requisitante encontrado.' }"
                >
                    <template slot="stock" slot-scope="text">{{ text ? text : "--" }}</template>
                    <template slot="total" slot-scope="text, store">
                        <span class="rdm-money">{{ calculateAmount(store) | currency }}</span>
                    </template>
                </a-table>
                <TypingsPage
                    v-else-if="tab === 'TYPINGS'"
                    :description="product.pro_descricao"
                    :request_id="request_id"
                    :product_id="product.pro_id"
                />
                <OrdersComponent
                    v-else
                    :description="product.pro_descricao"
                    :product_id="product_id"
                    :request_id="request_id"
                />
            </div>

            <div class="rdm-foot">
                <a-button @click="$emit('close')">Fechar</a-button>
            </div>
        </div>
    </a-modal>
</template>

<script>
import { mapState } from "vuex";
import QuotationService from "@/services/QuotationService";
import ErrorHandlerService from "@/services/ErrorHandlerService";
import { perm_mixin } from "@/mixins/permission.mixin";
import OrdersComponent from "@/modals/products/request-details/orders/_orders.component.vue";
import TypingsPage from "@/modals/products/request-details/typings/typings.page.vue";

export default {
    name: "RequestDetailsV2Modal",
    mixins: [perm_mixin],
    components: { OrdersComponent, TypingsPage },
    props: {
        product: { type: Object, required: true },
        product_id: { type: [String, Number], required: true },
        request_id: { type: [String, Number], required: true },
        seller_id: { type: [String, Number], default: undefined },
        price: { type: [String, Number], default: 0 },
    },
    data() {
        return {
            service: new QuotationService(),
            tab: "STORES",
            loading: false,
            stores: [],
            storeColumns: [
                { title: "ID", dataIndex: "codSolicitacao", key: "codSolicitacao" },
                { title: "Empresa", dataIndex: "descricaoLoja", key: "descricaoLoja" },
                { title: "Req.", dataIndex: "quantidade", key: "quantidade", align: "center" },
                { title: "Est.", dataIndex: "estoque", key: "estoque", align: "center", scopedSlots: { customRender: "stock" } },
                { title: "Pedido", dataIndex: "quantidadeSugestao", key: "quantidadeSugestao", align: "center" },
                { title: "Total item", key: "total", align: "right", scopedSlots: { customRender: "total" } },
            ],
        };
    },
    computed: {
        ...mapState(["user"]),
        myStore() {
            const onlyMyCompany = (this.perms || []).some((p) => p.resource === "MY_COMPANY" && p.action === "READ");
            return onlyMyCompany && this.user ? this.user.store_id : undefined;
        },
        visibleStores() {
            if (this.myStore) return this.stores.filter((s) => s.codLoja == this.myStore).slice(0, 1);
            return this.stores.filter((s) => s.loj_excluido != "1");
        },
    },
    created() {
        this.product.idProduto = this.product.pro_id;
        this.loadStores();
    },
    methods: {
        loadStores() {
            this.loading = true;
            this.service
                .getLojasQuantidade(this.product_id, this.request_id, this.seller_id)
                .then(({ data }) => {
                    this.stores = (data.produtos || []).map((s) => ({
                        ...s,
                        quantidadeSugestao: s.quantidadeSugestao == null ? s.quantidade : s.quantidadeSugestao,
                    }));
                })
                .catch((error) => {
                    ErrorHandlerService.handle(error, this.$store);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        calculateAmount(store) {
            const result = this.price * store.quantidadeSugestao;
            const byPackage = this.product.flag_generico == 0 && !this.product.pro_principal && this.user && this.user.request_type != 1;
            return byPackage ? parseFloat(this.product.qtd_embalagem) * result : result;
        },
    },
};
</script>

<style lang="scss" scoped>
.rdm-modal {
    max-height: 90vh;
    background: #fff;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
.rdm-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 18px 20px 6px;

    h3 {
        font-size: 16px;
        font-weight: 600;
        color: #262626;
    }
}
.rdm-sub {
    font-size: 13px;
    color: #8c8c8c;
    margin-top: 2px;
}
.rdm-x.ant-btn,
.rdm-x.ant-btn:focus,
.rdm-x.ant-btn:active {
    width: 28px;
    height: 28px;
    padding: 0;
    border: none;
    background: none;
    border-radius: 6px;
    color: #8c8c8c;
    box-shadow: none;
    display: flex;
    align-items: center;
    justify-content: center;
}
.rdm-x.ant-btn:hover {
    background: #f0f0f0;
    color: #262626;
}
.rdm-tabs {
    padding: 0 20px;

    ::v-deep .ant-tabs-bar {
        margin-bottom: 0;
    }
}
.rdm-body {
    flex: 1;
    overflow-y: auto;
    padding: 12px 20px;
    min-height: 200px;
}
.rdm-money {
    white-space: nowrap;
}
.rdm-foot {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 14px 20px;
    border-top: 1px solid #f0f0f0;
}
</style>

<style lang="scss">
.rdm-wrap {
    .ant-modal {
        min-width: 600px;
        max-width: 95vw;
    }

    .ant-modal-content {
        padding: 0;
        border-radius: 10px;
        overflow: hidden;
    }

    .ant-modal-body {
        padding: 0;
    }
}
</style>
